export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              联系投稿
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              欢迎与我们取得联系，无论是影片推荐、合作洽谈还是问题反馈，我们都会及时回复
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/30">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">投稿邮箱</h3>
                <p className="text-xs text-foreground-500">submit@8090cinema.com</p>
                <p className="text-xs text-foreground-400 mt-1">影片推荐 · 内容建议 · 问题反馈</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-accent-500/10 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-group-line text-accent-400 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">商务合作</h3>
                <p className="text-xs text-foreground-500">biz@8090cinema.com</p>
                <p className="text-xs text-foreground-400 mt-1">广告合作 · 版权合作 · 品牌联动</p>
              </div>

              <div className="text-center">
                <div className="w-12 h-12 rounded-xl bg-green-500/10 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-wechat-line text-green-400 text-xl"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-2">微信服务号</h3>
                <p className="text-xs text-foreground-500">8090影院服务号</p>
                <p className="text-xs text-foreground-400 mt-1">新片推送 · 影视资讯 · 活动通知</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-200/20 text-center">
              <p className="text-xs text-foreground-400">
                工作日 9:00-18:00 期间，邮件回复通常在2小时内。欢迎广大影迷推荐优秀影片资源，共同丰富8090影院的免费电影大全。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}